import { useQuery } from '@provision/graphql-client';
import { isNullish } from 'remeda';
import { GET_TRIAGE_SETTINGS_PAGE_DATA_QUERY } from 'src/graphql/entities/conversation-triage/conversation-triage.operations';
import { GetTriageSettingsPageDataQuery } from 'src/graphql/entities/conversation-triage/conversation-triage.types';
import { useNotifications } from 'src/utils/hooks';

export const useTriageSettingsPageData = (partnerId: number | null) => {
  const { showErrorAlert } = useNotifications();

  const { data, loading, error, refetch } = useQuery<GetTriageSettingsPageDataQuery>(
    GET_TRIAGE_SETTINGS_PAGE_DATA_QUERY,
    {
      variables: { partnerId },
      skip: isNullish(partnerId),
      fetchPolicy: 'cache-and-network',
      // ttl: 0 opts out of the 12h TTL link cache so refetch() after a manage
      // mutation (create/rename/set-default/delete) actually hits the network
      // instead of being served the pre-mutation cached response.
      context: { ttl: 0 },
      onError: (queryError) => {
        console.error(queryError);
        showErrorAlert('Failed to load Triage Intelligence settings, please try again');
      },
    },
  );

  return {
    data: data?.getTriageSettingsPageData,
    isLoading: loading && !data,
    error,
    refetch,
  };
};
